var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank8 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 82,
  height: 103,
  viewBox: "0 0 82 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_379)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_379)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.318 59.436C31.99 61.0213 31.826 62.4427 31.826 63.7C31.826 65.4493 32.2087 66.8433 32.974 67.882C33.7393 68.9207 35.0787 69.44 36.992 69.44C38.5227 69.44 39.862 69.03 41.01 68.21C42.2127 67.39 43.1967 66.324 43.962 65.012C44.7273 63.6453 45.3013 62.1147 45.684 60.42C46.1213 58.6707 46.34 56.894 46.34 55.09C46.34 53.3953 45.9573 52.0287 45.192 50.99C44.4267 49.9513 43.0873 49.432 41.174 49.432C39.8073 49.432 38.632 49.7053 37.648 50.252C36.7187 50.744 35.8987 51.4547 35.188 52.384C34.532 53.2587 33.958 54.3247 33.466 55.582C33.0287 56.7847 32.646 58.0693 32.318 59.436ZM38.714 33.606C38.4407 34.9727 38.304 36.0387 38.304 36.804C38.304 38.4987 38.6867 39.756 39.452 40.576C40.2173 41.3413 41.3107 41.724 42.732 41.724C43.6067 41.724 44.5087 41.5053 45.438 41.068C46.3673 40.6307 47.2147 39.9473 47.98 39.018C48.7453 38.0887 49.3467 36.9133 49.784 35.492C50.276 34.0707 50.522 32.4033 50.522 30.49C50.522 27.2647 49.046 25.652 46.094 25.652C42.2127 25.652 39.7527 28.3033 38.714 33.606ZM20.51 59.6C21.2753 55.9373 22.724 52.794 24.856 50.17C27.0427 47.546 29.858 45.906 33.302 45.25L33.384 45.086C32.1813 44.758 31.17 44.3207 30.35 43.774C29.53 43.1727 28.874 42.4893 28.382 41.724C27.89 40.9587 27.5347 40.1387 27.316 39.264C27.0973 38.3893 26.988 37.4873 26.988 36.558C26.988 36.1207 27.0153 35.6833 27.07 35.246C27.1247 34.8087 27.2067 34.3713 27.316 33.934C28.5187 28.2487 30.8967 24.176 34.45 21.716C38.0033 19.2013 42.4313 17.944 47.734 17.944C52.2167 17.944 55.7153 18.8187 58.23 20.568C60.7447 22.3173 62.002 25.16 62.002 29.096C62.002 30.08 61.8653 31.3647 61.592 32.95C61.3733 34.5353 60.854 36.148 60.034 37.788C59.2687 39.3733 58.148 40.8493 56.672 42.216C55.196 43.5827 53.228 44.5393 50.768 45.086L50.686 45.25C53.2007 45.7967 55.0593 46.9447 56.262 48.694C57.4647 50.4433 58.066 52.63 58.066 55.254C58.066 55.9647 57.984 57.0033 57.82 58.37C57.656 59.682 57.3007 61.158 56.754 62.798C56.2073 64.438 55.442 66.1053 54.458 67.8C53.474 69.4947 52.1347 71.0527 50.44 72.474C48.7453 73.8407 46.668 74.9613 44.208 75.836C41.8027 76.7107 38.878 77.148 35.434 77.148C32.2633 77.148 29.6667 76.7653 27.644 76C25.676 75.2347 24.118 74.2507 22.97 73.048C21.822 71.8453 21.0293 70.506 20.592 69.03C20.2093 67.4993 20.018 65.9687 20.018 64.438C20.018 62.6887 20.182 61.076 20.51 59.6Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_379",
  x: -4,
  y: 0.94397,
  width: 86.002,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_379"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_379",
  result: "effect2_dropShadow_1_379"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_379",
  result: "effect3_dropShadow_1_379"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_379",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_379",
  x: 16.0181,
  y: 17.944,
  width: 49.9839,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_379"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_379",
  result: "shape"
})))));
export default SvgRank8;